// src/components/EventForm/HeaderSection.js
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Typography from '../../components/Typography';
import { theme } from '../../theme';
import { useTranslation } from 'react-i18next';
import InputTextArea from '../Input/InputTextArea';

const HeaderSection = ({ title, onTitleChange, error }) => {
  const { t } = useTranslation('createEvent');
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <Wrapper>
      <InputWrapper>
        <TitleInputText
          ref={inputRef}
          name="title"
          value={title}
          onChange={onTitleChange}
          placeholder={t('eventForm.eventTitle.titlePlaceholder')}
          $variant={error ? 'error' : ''}
          required
        />
        {error &&
          <ErrorMessage>
            <Typography as="p" $variant="body-2-medium" color={theme.colors.errorMain}>
              {error}
            </Typography>
          </ErrorMessage>
        }
      </InputWrapper>
    </Wrapper>
  );
};

export default HeaderSection;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  width: 100%;
`;

const InputWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  // gap: ${({ theme }) => theme.sizing.xxs};
`;

const TitleInputText = styled(InputTextArea)`
  border: none;
  border: 1px transparent;
  field-sizing: content;
  font-size: 32px;
  font-weight: 600;
  resize: none;
  
  &:focus {
    border: 1px transparent;
    outline: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 24px;
    border: 1px solid ${({ theme }) => theme.border.defaultWeak};
    background-color: ${({ theme }) => theme.fill.defaultSubtle};

    &:focus {
      border: 1px solid ${({ theme }) => theme.border.inverseMain};
      outline: none;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 18px;
  }
`;

const ErrorMessage = styled.div`
  display: flex;
  padding-top: ${({ theme }) => theme.sizing.xs};
`;
